export default { 
    next: 'Próximo: ',
    previous: 'Anterior: ',
    noBirthTimeWarning: "{user}, essa sessão está incompleta porque não temos suas informações de Ascendente e Meio do Céu. Adicione seu horário de nascimento <a href='/my-profile?area=pessoal'>editando seu perfil</a> e desfrute de tudo o que o {guideName} pode oferecer.",

    paywall: { 
        buy: { 
            launchPriceOffer: "Preço de lançamento!",
            discountForSubscriber: "DE <span>{price}</span> POR",
            payConditionsWithoutInstallments: "No Pix ou Cartão de crédito",
            disclaimer: "Ao comprar produtos do Astrolink você concorda com os nossos <a href='/termos'>Termos de Uso</a>",
            directBuyPrice: "ou à vista: <strong>R${price}</strong>",
            moreOptions: "Opções de parcelamento sem juros estão disponíveis <a href='/{guideLink}' target='_blank'>direto no site!</a>",
            creditCard: "Comprar com Cartão",
            pix: "Comprar com Pix",
            installments: "<small>{installments}x</small> {value}",
            fullPriceInstallments: "DE {installments}x <span>{value}</span> POR",
            directPayWithInstallmentsSubscriber: "ou à vista: <span>de {fullValue}</span> por <strong>{subscriberValue}</strong>",
            directPayWithInstallments: "ou à vista: <strong>{value}</strong>",
            payConditionsWithInstallments: "No Pix ou Parcelamento em até {maxInstallments}x sem juros!",
            payWithCreditCard: "Comprar com Cartão",
            payWithPix: "Comprar com Pix",
        },

        notSubscriber: {
            title: "Desconto para assinantes!",
            premiumCTA: "🌟 Veja nossos Planos Premium 🌟",
            disclaimer: "Ao comprar produtos do Astrolink você concorda com os nossos <a href='/termos'>Termos de Uso</a>"
        },

        alreadySubscriber: { 
            title: "🌟 Seu desconto está ativo! 🌟",
            description:  "Parabéns {user}! Por ser cliente Premium <strong>você já garantiu {discount}% OFF</strong> no seu {guideName} e em qualquer outro conteúdo extra!"
        },

        subscription: { 
            cta1: "Assine agora!",
            cta2: "Quero ser Premium",

            benefits: { 
                extraMaps: "Mapas Extras Ilimitados",
                horoscope: "Horóscopo Futuro",
                compatibility: "Compatibilidade Astrológica",
                tarot: "Tarot Tradicional, do Amor e com IA",
                biorhythm: "Análise de Biorritmo",
                lunarCycle: "Ciclo Lunar",
                lunarNode: "Nodos Lunares"
            },

            muchMore: '+ Assistente de Interpretação, Diário Astrológico e muito mais!'
        },
    }
}